<template>
  <div>
    <div class="product-list" v-for="(item,index) in prodStockDocs" :key="index">
      <div>
        <div class="content_wrap" @click="toProductDetail(item.id)">
          <div class="product-img">
            <img :src="item.imgAddress" alt />
          </div>
          <!-- 商品信息 -->
          <div class="content">
            <ul>
              <li>{{item.model}}</li>
              <li>品牌：{{item.brand}}</li>
              <li>封装：{{item.pack}}</li>
              <li>库存：{{item.inventory}}</li>
            </ul>
          </div>
        </div>
        <!-- 销售单价 -->
        <div class="sales-price">
          <span>销售单价：</span>
          <ul :class="item.rotate ? 'open-wrap' : 'close-wrap'">
            <li v-for="(price,index) in item.prices" :key="index">
              <span>{{price.moq}}+：</span>
              <span class="price">￥{{price.price}}</span>
            </li>
          </ul>
          <div class="arrow" @click="openPrice(item)" :class="item.rotate ? 'bottom-arrow' : 'up-arrow'">
            <van-icon name="arrow-up" size="20px" />
          </div>
        </div>
      </div>
      <!-- 加入购物车 -->
      <div class="add-cart" @click="addCart(item)">
        <van-icon name="cart-o" size="18px" color="#fff"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rotate: false
    };
  },
  props:{
    prodStockDocs:Array
  },
  methods: {
    openPrice(item) {
      item.rotate = !item.rotate
    },
    toProductDetail(id){
      this.$router.push({
        name: "productDetails",
        query:{
            productId:id
        }
      });
    },
    //添加到购物车
    addCart(list){
      let data = {
        stockId:list.id,
        qty:list.moq,
        count:1
      }
      this.$store.dispatch('addCartList',data)
    }
  }
};
</script>

<style lang="less" scoped>
.product-list {
  border-bottom: 20px solid #f5f5f5;
  padding: 20px 30px;
  background: #fff;
  display: flex;
  .content_wrap {
    display: flex;
  }
  .product-img {
    width: 150px;
    height: 150px;
    border: 1px solid #f2f2f2;
    overflow: hidden;
    text-align: center;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .content {
    margin: 10px 0 0 20px;
    width: 400px;
    ul {
      li {
        line-height: 35px;
        font-size: 26px;
        color: #666;
      }
      li:first-child {
        font-size: 30px;
        color: #333;
      }
    }
  }
  .sales-price {
    font-size: 24px;
    color: #333;
    display: flex;
    margin-top: 30px;
    .priceHeight {
      overflow: hidden;
    }
    ul {
      margin-left: 50px;
      li {
        text-align: right;
        line-height: 35px;
        .price {
          color: #ff6600;
          min-width: 112px;
          display: inline-block;
          text-align: left;
        }
      }
    }
    .open-wrap {
      height: auto;
    }
    .close-wrap {
      height: 35px;
      overflow: hidden;
    }
    .arrow {
      margin-left: 50px;
      height: 40px;
    }
    .up-arrow {
      transition: 0.3s;
      transform: rotate(180deg);
    }
    .bottom-arrow {
      transition: 0.3s;
      transform: rotate(0);
    }
  }
  .add-cart {
    width: 50px;
    height: 50px;
    background: #ff9900;
    text-align: center;
    border-radius: 50%;
    padding-top: 7px;
    box-sizing: border-box;
    align-self: center;
  }
}
</style>